module.exports = __webpack_public_path__ + "img/about-img-2-300x400.868fc929.jpg";